import { useAppSelector } from 'dux/app/hooks';

import Typography from 'Components/Typography';

import { SKINCARE_CART_URL } from 'constants/cart';
import currencies from 'constants/currencies';

import defaultImage from 'assets/images/promotionalModals/skincare-minis-promotion-modal.jpg';

import { formatPriceWithCurrency } from 'utils/currencies';

import { getCurrencyFromCart } from 'dux/checkoutCart/selectors';

const STARTER_SET_PRICE = 65;

const CheckoutCommunication = () => {
  const currency = useAppSelector(getCurrencyFromCart);
  const price = currency === currencies.CAD ? 89 : 65;
  return (
    <>
      Subscribe to skincare and get a personalized trial-size routine (
      {formatPriceWithCurrency({ price, currency, minimumFractionDigits: 0 })}
      &nbsp;value)&nbsp;
      <b>FREE</b>
    </>
  );
};

const content = {
  banner: 'Claim your free Skincare Starter Set',
  popUpModal: {
    [currencies.USD]: {
      badge: (
        <>
          <b>FREE</b>
          <br />
          <Typography variant="p3">
            {formatPriceWithCurrency({
              price: STARTER_SET_PRICE,
              currency: currencies.USD,
              minimumFractionDigits: 0,
            })}
            &nbsp;VALUE
          </Typography>
        </>
      ),
      image: defaultImage,
      headerTitle: 'TRY CUSTOM SKINCARE FOR FREE',
      title: 'Free Skincare Starter Set',
      description: (
        <>
          Get a <b>FREE</b> trial-size routine (
          {formatPriceWithCurrency({
            price: STARTER_SET_PRICE,
            currency: currencies.USD,
            minimumFractionDigits: 0,
          })}{' '}
          value) when you subscribe to skincare.
        </>
      ),
      cta: {
        consultationCompleted: {
          linkTo: SKINCARE_CART_URL,
          ctaLabel: 'GET YOUR FREE ROUTINE',
        },
        consultationNotCompleted: {
          linkTo: '/consultation/skincare/first-question',
          ctaLabel: 'GET YOUR FREE ROUTINE',
        },
      },
      conditions: (
        <>
          *Get your Skincare Starter Set (
          {formatPriceWithCurrency({
            price: STARTER_SET_PRICE,
            currency: currencies.USD,
            minimumFractionDigits: 0,
          })}{' '}
          value) when you subscribe to Cleanser, Serum, and Moisturizer. Offer valid between XX
          through XX at 12:00am EST, when your subscription order is placed by XX at 12:00am EST.
          Free shipping and 15% off will be applied to all following skincare subscription orders.
          Subscribe to both haircare and skincare to receive an additional 5% discount, for a total
          discount of 20%. Exceptions may apply. Offer valid while stocks last. For full details on
          our return policy,{' '}
          <a href="https://prose.com/faq/5f3da05bceb96c001a595c02" target="_blank">
            click here
          </a>
          .
        </>
      ),
    },
    [currencies.CAD]: {
      badge: <b>FREE</b>,
      image: defaultImage,
      headerTitle: 'TRY CUSTOM SKINCARE FOR FREE',
      title: 'Free Skincare Starter Set',
      description: (
        <>
          Get a <b>FREE</b> trial-size routine when you subscribe to skincare.
        </>
      ),
      cta: {
        consultationCompleted: {
          linkTo: SKINCARE_CART_URL,
          ctaLabel: 'GET YOUR FREE ROUTINE',
        },
        consultationNotCompleted: {
          linkTo: '/consultation/skincare/first-question',
          ctaLabel: 'GET YOUR FREE ROUTINE',
        },
      },
      conditions: (
        <>
          *Get your Skincare Starter Set when you subscribe to Cleanser, Serum, and Moisturizer.
          Offer valid between XX through XX at 12:00am EST, when your subscription order is placed
          by XX at 12:00am EST. Free shipping and 15% off will be applied to all following skincare
          subscription orders. Subscribe to both haircare and skincare to receive an additional 5%
          discount, for a total discount of 20%. Exceptions may apply. Offer valid while stocks
          last. For full details on our return policy,{' '}
          <a href="https://prose.com/faq/5f3da05bceb96c001a595c02" target="_blank">
            click here
          </a>
          .
        </>
      ),
    },
  },
  bottomModal: {
    [currencies.USD]: {
      title: 'free skincare Starter Set',
      description: (
        <>
          Subscribe to skincare and get a personalized trial-size routine (
          {formatPriceWithCurrency({
            price: STARTER_SET_PRICE,
            currency: currencies.USD,
            minimumFractionDigits: 0,
          })}
          &nbsp;value)&nbsp;<b>FREE</b>
        </>
      ),
      conditions: (
        <>
          *Get your Skincare Starter Set (
          {formatPriceWithCurrency({
            price: STARTER_SET_PRICE,
            currency: currencies.USD,
            minimumFractionDigits: 0,
          })}{' '}
          value) when you subscribe to Cleanser, Serum, and Moisturizer. Offer valid between XX
          through XX at 12:00am EST, when your subscription order is placed by XX at 12:00am EST.
          Free shipping and 15% off will be applied to all following skincare subscription orders.
          Subscribe to both haircare and skincare to receive an additional 5% discount, for a total
          discount of 20%. Exceptions may apply. Offer valid while stocks last. For full details on
          our return policy,{' '}
          <a href="https://prose.com/faq/5f3da05bceb96c001a595c02" target="_blank">
            click here
          </a>
          .
        </>
      ),
    },
    [currencies.CAD]: {
      title: 'free skincare Starter Set',
      description: (
        <>
          Subscribe to skincare and get a personalized trial-size routine <b>FREE</b>
        </>
      ),
      conditions: (
        <>
          *Get your Skincare Starter Set when you subscribe to Cleanser, Serum, and Moisturizer.
          Offer valid between XX through XX at 12:00am EST, when your subscription order is placed
          by XX at 12:00am EST. Free shipping and 15% off will be applied to all following skincare
          subscription orders. Subscribe to both haircare and skincare to receive an additional 5%
          discount, for a total discount of 20%. Exceptions may apply. Offer valid while stocks
          last. For full details on our return policy,{' '}
          <a href="https://prose.com/faq/5f3da05bceb96c001a595c02" target="_blank">
            click here
          </a>
          .
        </>
      ),
    },
  },
  checkoutCommunication: {
    title: 'free skincare Starter Set',
    description: <CheckoutCommunication />,
    terms: 'See terms & conditions',
  },
};

export default content;
